export default __webpack_public_path__ + "static/media/auth-img.9302755e.png";